<!--  -->
<template>
  <re-dialog
    title="配置说明"
    :value.sync="visible"
    :width="600"
    :show-confirm="false"
    cancel-text="关闭"
  >
    <div class="configuration-notes">
      <p class="title">报告导出配置说明：</p>
      <p>
        1.<span v-text="'{{ 项目名称 }}'" />：前台导出pdf报告时，替换成该项目项目名称；
      </p>
      <p>
        2.<span v-text="'{{ 中心名称 }}'" />：前台导出pdf报告时，替换成该日程计划的中心名称；
      </p>
      <p>
        3.<span v-text="'{{ 方案编号 }}'" />：前台导出pdf报告时，替换成该项目方案编号；
      </p>
      <p>
        4. 若“<span v-text="'{{ 数据字段 }}'" />”在报告设计中不存在，导出pdf报告时，显示配置内容，例如“<span
          v-text="'{{ input_1680697269399 }}'"
        />”在报告设计中不存在，导出pdf报告时，显示“<span
          v-text="'{{ input_1680697269399 }}'"
        />”；
      </p>
      <p>
        5. 若字段是单选项或多选选，“<span v-text="'{{数据字段}}'" />”导出pdf报告时，显示所有选项名称并勾选前台选择的选项；
      </p>
      <p>6. 若模板未配置，前台导出pdf时提示“管理员未配置报告模板，导出失败”</p>
      <p>7. 其他固定标签：</p>
      <p class="intent">
        本次发现问题：<span v-text="'{{#list}}'" />，获取该中心，该类型报告，实际开始日期≤发现时间≤实际结束日期的问题发现，显示问题编号、问题描述、监查项、筛选号、发现时间、自定义属性、创建人、创建时间的列；
      </p>
      <p class="intent">
        本次方案违背：<span v-text="'{{#schemelist}}'" />，获取该中心，实际开始日期≤发现日期≤实际结束日期的方案违背，显示方案违背编号、筛选号、方案违背描述、发现日期、自定义属性、添加人、添加时间的列；
      </p>
      <p class="intent">
        本次SAE：<span v-text="'{{#saelist}}'" />，获取该中心，实际开始日期≤获知时间≤实际结束日期的SAE，显示筛选号、SAE名称、获知日期、是否已完成上报、完成上报日期、自定义属性的列、创建人、创建时间的列；
      </p>
      <p class="intent">
        申请人：<span v-text="'{{ applicant }}'" />，获取日程计划申请人的姓名，报告待审阅、报告定稿、报告退回、随访信已发送
        获取值，其他状态显示空；
      </p>
      <p class="intent">
        审核人：<span v-text="'{{ reviewer }}'" />，获取该报告最后审核通过/退回的审核人的姓名，报告定稿、报告退回、随访信已发送
        获取值，其他状态显示空；
      </p>
      <p class="intent">
        报告提交日期：<span v-text="'{{ submitTime }}'" />，报告最后一次提交的日期，报告待审阅、报告定稿、报告退回、随访信已发送
        获取值，其他状态显示空；
      </p>
      <p class="intent">
        报告定稿日期：<span v-text="'{{ finalTime }}'" />，获取该报告审核通过的日期，报告定稿、随访信已发送
        获取值，其他状态显示空；；
      </p>
      <p class="intent">
        实际起止日期：<span v-text="'{{ time }}'" />，获取报告的实际起止日期；
      </p>
      <p class="intent">
        待解决的问题：<span v-text="'{{#waitlist}}'" />，显示该项目该中心该监查类型，问题“发现时间”小于该报告“实际结束日期”，且问题“解决日期”大于该报告“实际结束日期”；
      </p>
      <p class="intent">
        本次监查解决的问题：<span v-text="'{{#thislist}}'" />，显示该项目该中心该监查类型，问题“发现时间”小于该报告“实际结束日期”，且问题“解决日期”小于该报告“实际结束日期”且问题“解决日期”大于该项目该中心该监查类型上一次报告的实际结束日期的问题发现；
      </p>
      <p class="intent">
        审阅结果：<span v-text="'{{ approveResult }}'" />，显示选择框“同意”、“不同意”，若报告是报告定稿、报告退回、随访信已发送状态，根据最后一次的审阅记录，勾选“同意”/“不同意”选项，反之，页面不勾选“同意”/“不同意”选项；
      </p>
      <p class="intent">
        审阅意见：<span v-text="'{{ approveRemark }}'" />，抓取最后的报告审阅意见，报告定稿、报告退回、随访信已发送
        获取值，其他状态显示空；
      </p>

      <p class="mt-2 title">确认信&amp;随访信配置说明：</p>
      <p class="intent">
        支持上传word文档，word文档中填写“<span v-text="'{{ 数据字段 }}'" />”，前台导出pdf报告时，该“<span v-text="'{{ 数据字段 }}'" />”替换成前台编写报告输入的值；
      </p>
      <p>特殊的：</p>
      <p>
        1. 日程计划起止日期：<span v-text="'{{ time }}'" />，获取日程计划开始日期~结束日期，输出格式“YYYY年MM月DD日 ~
        YYYY年MM月DD日”；
      </p>
      <p>
        2. 方案编号：<span v-text="'{{ projectProtocolNumber }}'" />，获取该项目的方案编号；
      </p>
      <p>
        3. 项目名称：<span v-text="'{{ projectName }}'" />，获取该项目的项目名称；
      </p>
      <p>
        4. 申请人联系电话：<span v-text="'{{ phone }}'" />，获取日程计划申请人的联系电话，来源于后台用户管理；
      </p>
      <p>
        5. 申请人项目角色：<span v-text="'{{ roleName }}'" />，获取日程计划申请人的在该项目的项目角色；
      </p>
      <p>
        6. 申请人姓名：<span v-text="'{{ realName }}'" />，获取日程计划申请人的姓名；
      </p>
      <p>
        7. 中心名称：<span v-text="'{{ partnerName }}'" />，添加日程计划的相关中心；
      </p>
      <p>
        8. 中心地址：<span v-text="'{{ address }}'" />，添加日程计划的相关中心的地址；
      </p>
      <p>9. 申办方：<span v-text="'{{ name }}'" />,获取项目的申办方；</p>
      <p>
        10. 既往未解决问题：<span v-text="'{{#waitlist}}'" />，<span
          v-text="'{{ 既往未解决问题 }}'"
        />，获取该中心，该类型报告，解决日期为空的问题发现，显示问题编号、问题描述、监查项、受试者、发现时间、自定义属性、创建人、创建时间的列；
      </p>
      <p>
        11. 本次发现问题：<span v-text="'{{#list}}'" />，获取该中心，该类型报告，实际开始日期≤发现时间≤实际结束日期的问题发现，显示问题编号、问题描述、监查项、筛选号、发现时间、自定义属性、创建人、创建时间的列；
      </p>
      <p>
        12. 本次方案违背：<span v-text="'{{#schemelist}}'" />，获取该中心，实际开始日期≤发现日期≤实际结束日期的方案违背，显示方案违背编号、筛选号、方案违背描述、发现日期、自定义属性、添加人、添加时间的列；
      </p>
      <p>
        13. 项目经理：<span v-text="'{{ projectPmName }}'" />,获取项目的“项目经理”；
      </p>
      <p>
        14. 项目经理联系电话：<span v-text="'{{ projectPmPhone }}'" />
        ,获取项目的“项目经理”用户的联系电话，来源于后台用户管理；
      </p>
      <p>
        15. 申请人邮箱：<span v-text="'{{ email }}'" />，获取日程计划申请人的邮箱，来源于后台用户管理；
      </p>
      <p>
        16. 项目编号：<span v-text="'{{ projectNumber }}'" />，获取该项目的项目编号；
      </p>
      <p>
        17. 主要研究者：<span v-text="'{{ piName }}'" />，获取该中心，主要研究者姓名；
      </p>
    </div>
  </re-dialog>
</template>

<script>
export default {
  name: 'ConfigurationNotes',
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-notes {
  height: 500px;
  overflow: auto;
  color: #333;
  .title {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .intent {
    // 首字母锁进
    text-indent: 2em;
  }
}
</style>
